import { render, staticRenderFns } from "./anquan.vue?vue&type=template&id=2907fdf3&"
import script from "./anquan.vue?vue&type=script&lang=js&"
export * from "./anquan.vue?vue&type=script&lang=js&"
import style0 from "./anquan.vue?vue&type=style&index=0&id=2907fdf3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports